import React from "react";
import {
  Box,
  Container,
  Image,
  Text,
  Heading,
  VStack,
  Flex,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import brandsdevider from "../../assets/about/brandsdevider.png";
import paajiIcon from "../../assets/home/paji.png";
import blogPlaceholder from "../../assets/blogs/blogimg.png";
import blogImage from "../../assets/about/blogimage.webp";
import Success from "../home/component/Success";
import Footer from "../header/Footer";
import useScrollAnimation from "component/useScrollAnimation";
import grey from "../../assets/flower/greyish.png";
import red from "../../assets/flower/redd.png";
import FlowerImage from "component/FlowerImage";

const BlogHome = () => {
  const navigate = useNavigate();
  useScrollAnimation();
  // Blog data
  const blogs = [
    {
      id: 1,
      title: "What is the branding, and why we need it?",
      description:
        "Let’s transform your ideas into a roaring success. As a trusted digital marketing company in Jaipur and one of the best SEO companies in India, we’re here to help. Reach out to us and experience the magic of Marwadi-style innovation!",
      category: "BRANDING",
      image: blogImage,
    },
    {
      id: 2,
      title: "What is the branding, and why we need it?",
      description:
        "Let’s transform your ideas into a roaring success. As a trusted digital marketing company in Jaipur and one of the best SEO companies in India, we’re here to help. Reach out to us and experience the magic of Marwadi-style innovation!",
      category: "BRANDING",
      image: blogImage,
    },
    {
      id: 3,
      title: "What is the branding, and why we need it?",
      description:
        "Let’s transform your ideas into a roaring success. As a trusted digital marketing company in Jaipur and one of the best SEO companies in India, we’re here to help. Reach out to us and experience the magic of Marwadi-style innovation!",
      category: "BRANDING",
      image: blogImage,
    },
  ];

  return (
    <>
      <Box position="relative" zIndex={0} overflow="visible">
        {/* Hero Section */}
        <Box
          bg="#005770"
          color="white"
          pt={{ base: "110px", md: "120px" }}
          pb={{ base: "30px", md: "50px" }}
          textAlign="center"
        >
          <Container maxW="container.md" px={{ base: 4, md: 0 }}>
           
            <Heading
              as={"h2"}
              fontSize={{ base: "xl", md: "4xl" }}
              color={"#F1DED0"}
              fontWeight="bold"
              className="fade-in-up"
            >
              Our Blogs
            </Heading>
            <Text
              fontSize={{ base: "sm", md: "md" }}
              mt={4}
              px={{ base: 2, md: 6 }}
              className="fade-in-up"
            >
              Let’s transform your ideas into a roaring success. As a trusted
              digital marketing company in Jaipur and one of the best SEO
              companies in India, we’re here to help. Reach out to us and
              experience the magic of Marwadi-style innovation!
            </Text>
            <FlowerImage src={grey} />
            <Box
              mt={{ base: 6, md: 10 }}
              position="relative"
              display="flex"
              justifyContent="center"
            >
              <Image
                src={blogPlaceholder}
                alt="Blog Image"
                borderRadius="md"
                boxShadow="lg"
                maxW={{ base: "90%", md: "400px" }}
                w="100%"
                maxH="300px"
                className="fade-in-up"
              />
              <Image
                src={paajiIcon}
                alt="Paaji Icon"
                position="absolute"
                bottom={{ base: "-20px", md: "-20px" }}
                right={{ base: "-10px", md: "50px" }}
                maxW={{ base: "60px", md: "100px" }}
                data-animated="true"
                className="fade-in-up"
              />
               <FlowerImage
              src={red}
              top={{ base: "45%", md: "88%" }}
              right={{ base: "5%", md: "0" }}
            />
            </Box>
          </Container>
        </Box>

        <Image
          src={brandsdevider}
          mt={{ base: -2, md: -10 }}
          alt="Brands Divider"
          w="100%"
        />

        <Container maxW="container.lg" py={10}>
          <VStack spacing={8}>
            {blogs.map((blog) => (
              <Flex
                key={blog.id}
                bg="white"
                boxShadow="md"
                borderRadius="md"
                p={4}
                w="100%"
                direction={{ base: "column", md: "row" }}
                align="center"
                gap={6}
                cursor="pointer"
                onClick={() => navigate("/blog1")}
                className="fade-in-up"
              >
                {/* Blog Image */}
                <Image
                  src={blog.image}
                  alt={blog.title}
                  borderRadius="md"
                  maxW={{ base: "100%", md: "200px" }}
                  className="fade-in-up"
                />

                {/* Blog Content */}
                <Box flex="1" textAlign={{ base: "center", md: "left" }}>
                  <Text
                    fontSize="sm"
                    color="#A2B6BD"
                    textTransform="uppercase"
                    className="fade-in-up"
                  >
                    {blog.category}
                  </Text>
                  <Heading
                    fontSize={{ base: "md", md: "lg" }}
                    fontWeight="bold"
                    color="#005770"
                    className="fade-in-up"
                  >
                    {blog.title}
                  </Heading>
                  <Text
                    fontSize="sm"
                    mt={2}
                    color="#ABABB2"
                    className="fade-in-up"
                  >
                    {blog.description}
                  </Text>
                </Box>
              </Flex>
            ))}
          </VStack>
        </Container>

        <Success />
      </Box>
      <Footer />
    </>
  );
};

export default BlogHome;
